var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoteconnectionsmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.56 55.888L16.264 49.224L16.192 49.176C14.12 47.984 11.536 48.336 9.45599 49.536C7.37599 50.736 6.59999 52.32 8.65599 53.536L20.08 60.232C20.08 60.232 23.04 61.584 26.56 59.552C26.56 59.552 30.168 57.4 27.56 55.888Z",
    fill: "url(#paint0_linear_3890_386018)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.144 43.848C30.144 37.416 25.632 29.6 20.064 26.384C17.256 24.76 14.712 24.624 12.88 25.712L8.04797 28.504L9.98397 31.96C9.98397 32.04 9.98397 32.12 9.98397 32.2C9.98397 38.528 14.36 46.2 19.816 49.504L21.984 53.376L27.16 50.392C29.008 49.344 30.152 47.08 30.152 43.84L30.144 43.848Z",
    fill: "url(#paint1_linear_3890_386018)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1016 53.3134C26.0389 51.0402 26.0394 43.6699 22.1027 36.8514C18.166 30.0328 11.7829 26.3481 7.84555 28.6213C3.90825 30.8945 3.90775 38.2648 7.84443 45.0834C11.7811 51.9019 18.1642 55.5866 22.1016 53.3134Z",
    fill: "url(#paint2_linear_3890_386018)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3415 51.997C24.8579 49.9668 24.8575 43.3829 21.3406 37.2913C17.8236 31.1998 12.122 27.9074 8.60554 29.9376C5.08914 31.9678 5.08958 38.5518 8.60652 44.6433C12.1235 50.7349 17.8251 54.0272 21.3415 51.997Z",
    fill: "#EDECED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1519 53.288L22.0559 53.344C22.0559 53.344 22.1199 53.304 22.1519 53.288Z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.184 52.04C19.648 52.528 17.72 52.24 15.632 51.032C10.624 48.144 6.56801 41.12 6.56801 35.336C6.56801 32.744 7.384 30.848 8.73601 29.8C8.78401 29.76 8.84 29.72 8.888 29.688C8.832 29.712 8.776 29.744 8.72 29.776C6.968 30.672 5.88 32.744 5.88 35.736C5.88 41.512 9.936 48.544 14.944 51.432C17.392 52.848 19.608 53 21.24 52.128C21.392 52.048 21.544 51.952 21.688 51.848C21.528 51.92 21.36 51.984 21.192 52.04H21.184Z",
    fill: "url(#paint3_linear_3890_386018)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.632 51.032C10.624 48.144 6.56801 41.12 6.56801 35.336C6.56801 32.744 7.384 30.848 8.73601 29.8C8.78401 29.76 8.84 29.72 8.888 29.688C8.832 29.712 8.776 29.744 8.72 29.776C6.968 30.672 5.88 32.744 5.88 35.736C5.88 41.512 9.936 48.544 14.944 51.432C17.392 52.848 19.608 53 21.24 52.128C21.392 52.048 21.544 51.952 21.688 51.848C21.528 51.92 21.36 51.984 21.192 52.04C19.656 52.528 17.728 52.24 15.64 51.032H15.632Z",
    fill: "url(#paint4_linear_3890_386018)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.832 36.48C24.544 36.336 24.264 36.056 24.048 35.688C23.648 34.992 23.656 34.232 24.072 34L46.392 21.104C46.808 20.864 47.464 21.24 47.864 21.936C48.264 22.632 48.256 23.392 47.84 23.624L25.52 36.52C25.328 36.632 25.08 36.608 24.832 36.48Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1039 27.1359C59.1039 20.7039 54.5919 12.8879 49.0239 9.67194C46.2159 8.04794 43.6719 7.91194 41.8399 8.99994L37.0079 11.7919L38.9439 15.2479C38.9439 15.3279 38.9439 15.4079 38.9439 15.4879C38.9439 21.8159 43.3199 29.4879 48.7759 32.7919L50.9439 36.6639L56.1199 33.6799C57.9679 32.6319 59.1119 30.3679 59.1119 27.1279L59.1039 27.1359Z",
    fill: "url(#paint5_linear_3890_386018)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0616 36.5935C54.9989 34.3202 54.9994 26.9499 51.0628 20.1314C47.1261 13.3129 40.7429 9.62813 36.8056 11.9013C32.8683 14.1745 32.8678 21.5449 36.8045 28.3634C40.7412 35.1819 47.1243 38.8667 51.0616 36.5935Z",
    fill: "url(#paint6_linear_3890_386018)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3016 35.2771C53.818 33.2469 53.8176 26.6629 50.3006 20.5714C46.7837 14.4798 41.082 11.1875 37.5656 13.2177C34.0492 15.2479 34.0497 21.8318 37.5666 27.9234C41.0836 34.0149 46.7852 37.3073 50.3016 35.2771Z",
    fill: "#EDECED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.112 36.568L51.016 36.624C51.016 36.624 51.08 36.584 51.112 36.568Z",
    fill: "#9D9D9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.144 35.328C48.608 35.816 46.68 35.528 44.592 34.32C39.584 31.432 35.528 24.408 35.528 18.624C35.528 16.032 36.344 14.136 37.696 13.088C37.744 13.048 37.8 13.008 37.848 12.976C37.792 13 37.736 13.032 37.68 13.064C35.928 13.96 34.84 16.032 34.84 19.024C34.84 24.8 38.896 31.832 43.904 34.72C46.352 36.136 48.568 36.288 50.2 35.416C50.352 35.336 50.504 35.24 50.648 35.136C50.488 35.208 50.32 35.272 50.152 35.328H50.144Z",
    fill: "url(#paint7_linear_3890_386018)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.592 34.32C39.584 31.432 35.528 24.408 35.528 18.624C35.528 16.032 36.344 14.136 37.696 13.088C37.744 13.048 37.8 13.008 37.848 12.976C37.792 13 37.736 13.032 37.68 13.064C35.928 13.96 34.84 16.032 34.84 19.024C34.84 24.8 38.896 31.832 43.904 34.72C46.352 36.136 48.568 36.288 50.2 35.416C50.352 35.336 50.504 35.24 50.648 35.136C50.488 35.208 50.32 35.272 50.152 35.328C48.616 35.816 46.688 35.528 44.6 34.32H44.592Z",
    fill: "url(#paint8_linear_3890_386018)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3890_386018",
    x1: 11.08,
    y1: 58.544,
    x2: 24.88,
    y2: 50.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3890_386018",
    x1: 12.968,
    y1: 48.176,
    x2: 24.176,
    y2: 28.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3890_386018",
    x1: 4.89113,
    y1: 40.968,
    x2: 25.0591,
    y2: 40.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3890_386018",
    x1: 5.88,
    y1: 41.184,
    x2: 21.68,
    y2: 41.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3890_386018",
    x1: 5.88,
    y1: 41.184,
    x2: 21.68,
    y2: 41.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3890_386018",
    x1: 41.9199,
    y1: 31.4639,
    x2: 53.1359,
    y2: 12.0479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3890_386018",
    x1: 33.8513,
    y1: 24.248,
    x2: 54.0113,
    y2: 24.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3890_386018",
    x1: 34.832,
    y1: 24.464,
    x2: 50.64,
    y2: 24.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3890_386018",
    x1: 34.832,
    y1: 24.464,
    x2: 50.64,
    y2: 24.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteconnectionsmall);
export default __webpack_public_path__ + "static/media/remote connection small.c8bc0c97c449803f6ed449d9bb679257.svg";
export { ForwardRef as ReactComponent };